var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionaiTopmyuni(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107285",
    "data-name": "Group 107285",
    transform: "translate(-428 -576)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40442",
    "data-name": "Rectangle 40442",
    width: 32,
    height: 32,
    transform: "translate(428 576)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106168",
    "data-name": "Path 106168",
    d: "M17.942,2a.7.7,0,0,0-.291.062L2.4,9.2a.684.684,0,0,0-.4.63v1.186H33.885V9.825a.684.684,0,0,0-.4-.63L18.233,2.062A.7.7,0,0,0,17.942,2ZM4.2,12.4a2.233,2.233,0,0,0,1.269,1.386h.693v11.09H9.625V13.784H13.09v11.09h3.466V13.784h2.773v11.09h3.466V13.784H26.26v11.09h3.466V13.784h.693A2.233,2.233,0,0,0,31.688,12.4ZM6.052,26.26A2.031,2.031,0,0,0,4.079,28.34H31.805a2.03,2.03,0,0,0-1.972-2.079ZM3.972,29.726A2.031,2.031,0,0,0,2,31.805v1.386H33.885V31.805a2.03,2.03,0,0,0-1.972-2.079Z",
    transform: "translate(426 574.065)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionaiTopmyuni);
export default __webpack_public_path__ + "static/media/visionai_topmyuni.dea1087faaeb045ea4f644919ee4ed01.svg";
export { ForwardRef as ReactComponent };